import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CategoriesDropdown from './category-dropdown';
import { CategoryDropdownProps } from './type';
import { setSelectedCategoryName } from '../../../components/prospect/prospect-slice';
import { KanbanProspectListPayload } from '../../../components/prospect/types';
import { RootState } from '../../../store/root-reducer';

const CategoryDropdownContainer = (props: CategoryDropdownProps) => {
  const dispatch = useDispatch();
  const setActiveCategoryName = (categoryName: KanbanProspectListPayload) => {
    dispatch(setSelectedCategoryName(categoryName));
  };
  const contactField = useSelector(
    (state: RootState) => state?.sequence?.contactFields,
  );
  return (
    <CategoriesDropdown
      {...props}
      setActiveCategoryName={setActiveCategoryName}
      contactField={contactField}
    />
  );
};
export default CategoryDropdownContainer;
